import { render, staticRenderFns } from "./VueAutocomplete.vue?vue&type=template&id=10c60120&scoped=true"
import script from "./VueAutocomplete.vue?vue&type=script&lang=js"
export * from "./VueAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./VueAutocomplete.vue?vue&type=style&index=0&id=10c60120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c60120",
  null
  
)

export default component.exports